import packageJson from '../../package.json';

class Package {

    static package = null;

    constructor() {

        this.buildPackage();

    }

    buildPackage() {

        if (Package.package !== null) return null;

        this.package = {
            name: packageJson.name,
            version: packageJson.version,
        };

    }

    getPackage() {

        if (Package.package !== null) return Package.package;

        Package.package = packageJson;

        return Package.package;

    }

    getVersion() {

        const pack = this.getPackage();

        return pack.version;

    }

}

export default Package;